var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message),expression:"message"}],staticClass:"mb__alert-box mb__m-bottom-xs mb__add-color-red"},[_vm._v(" "+_vm._s(_vm.message)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }